
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vidya/[slug]",
      function () {
        return require("private-next-pages/vidya/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vidya/[slug]"])
      });
    }
  